// extracted by mini-css-extract-plugin
export default {"info-bar":"info-bar_info-bar__uwC+8"};